import React from 'react';
import PropTypes from 'prop-types';

import useAppContext from '../../context/useAppContext';

import Widget from '../../models/widget';
import { Route, Switch } from 'react-router-dom';
import Template from '../template/template';
import Loading from '../loading';
import PageError from '../../pages/error/pageError';
import { ToastContext } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import { ManagerContextProvider } from '../../pages/manager/components/context';
import OnlineTicketingSettings from '../../pages/widgets/online_ticketing/details/settings';
import OnlineTicketingTranslations from '../../pages/widgets/online_ticketing/details/translations';

export default function OnlineTicketingRouter({ path, organization, onlineTicketingId, history }) {
    const [context, setContext] = useAppContext();
    const toast = React.useContext(ToastContext);
    const { t } = useTranslation();

    const [, loading] = Widget.useApiModel(
        {
            id: onlineTicketingId,
            organizationId: organization.id,
            query: {
                usage__in: ['sale', 'resale', 'multi_events']
            },
            onSuccess: online_ticketing => {
                setContext({ online_ticketing });
            },
            onError: e => {
                if (e.code === 404) {
                    toast.error(t('pageNotFound'));
                } else {
                    toast.error(t('ticket.common.toast_error'));
                }

                history.push(`/ticket/O${organization.id}/online_ticketing`);
            }
        },
        [onlineTicketingId, organization, t, history]
    );

    if (loading || !context.online_ticketing) {
        return <Loading />;
    }

    return (
        <ManagerContextProvider>
            <Template organization={organization} online_ticketing={context.online_ticketing}>
                <Switch>
                    <Route
                        exact
                        path={`${path}/settings`}
                        render={({
                            match: {
                                params: { onlineTicketingId }
                            }
                        }) => <OnlineTicketingSettings organization={organization} onlineTicketingId={onlineTicketingId} />}
                    />
                    <Route
                        exact
                        path={`${path}/translations`}
                        render={({
                            match: {
                                params: { onlineTicketingId }
                            }
                        }) => <OnlineTicketingTranslations organization={organization} onlineTicketingId={onlineTicketingId} />}
                    />
                    {/* Error */}
                    <Route render={() => <PageError errorCode={404} backHomeUrl={`/ticket/O${organization.id}/online_ticketing/${onlineTicketingId}`} />} />
                </Switch>
            </Template>
        </ManagerContextProvider>
    );
}

OnlineTicketingRouter.propTypes = {
    match: PropTypes.string,
    organization: PropTypes.object,
    history: PropTypes.object.isRequired,
    onlineTicketingId: PropTypes.string
};
